<script setup>
const props = defineProps({
  chips: { type: Array, default: () => [] },
  expanded: { type: Boolean, default: false },
  open: { type: Boolean, default: false },
  heading: { type: String, default: '' },
  closeLabel: { type: String, default: '' }
})

const emit = defineEmits(['close'])

const ROLL_MS = 2400
const SLOTS = [
  { y: 0, s: 1, o: 1, z: 6 },
  { y: 60, s: 0.9, o: 0.55, z: 4 },
  { y: 113, s: 0.8, o: 0.24, z: 2 }
]
const HIDDEN_SLOT = { y: 165, s: 0.72, o: 0, z: 0 }

const reducedMotion = computed(() =>
  typeof matchMedia !== 'undefined' && matchMedia('(prefers-reduced-motion: reduce)').matches
)

const rolling = computed(() => props.expanded && !reducedMotion.value)
const active = ref(0)
const prevOffsets = new Map()
let rollTimer = null

watch(
  () => [rolling.value, props.chips.length],
  ([isRolling, length]) => {
    if (rollTimer) {
      clearInterval(rollTimer)
      rollTimer = null
    }
    active.value = 0
    prevOffsets.clear()
    if (!isRolling || length <= 0) return
    rollTimer = setInterval(() => {
      active.value = (active.value + 1) % length
    }, ROLL_MS)
  },
  { immediate: true }
)

onBeforeUnmount(() => {
  if (rollTimer) clearInterval(rollTimer)
})

const cardStyle = (i) => {
  if (!rolling.value) return undefined
  const n = props.chips.length
  let off = (((i - active.value) % n) + n) % n
  if (off > n / 2) off -= n
  const abs = Math.abs(off)
  const slot = abs <= 2 ? SLOTS[abs] : HIDDEN_SLOT
  const prev = prevOffsets.get(i)
  const wrap = prev !== undefined && Math.abs(off - prev) > 2
  prevOffsets.set(i, off)
  return {
    transform: `translate(-50%, calc(-50% + ${Math.sign(off) * slot.y}px)) scale(${slot.s})`,
    opacity: slot.o,
    zIndex: slot.z,
    ...(wrap ? { transition: 'none' } : {})
  }
}
</script>

<template>
  <div
    class="call-log-wrap starter-wrap"
    :class="{ open }"
  >
    <div class="log-head">
      <span>{{ heading }}</span>
      <button
        class="log-close"
        :aria-label="closeLabel"
        @click="emit('close')"
      >
        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
        </svg>
      </button>
    </div>
    <div class="starter-list">
      <div
        class="starter-stage"
        :class="{ rolling }"
      >
        <div
          v-for="(chip, i) in chips"
          :key="i"
          class="starter-card"
          :style="cardStyle(i)"
        >
          <span class="starter-avatar">
            <img :src="chip.avatar" alt="">
          </span>
          <span class="starter-text">
            <span class="starter-title">{{ chip.title }}</span>
            <span class="starter-q">"{{ chip.q }}"</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
